import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import '@mantine/core/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';

import { App } from './App';
import { SessionProvider } from './lib/session';

// The landing page's identity (site/): enamel blue for the shelving, and the
// bin-label yellow that marks where something can be put.
const theme = createTheme({
  primaryColor: 'enamel',
  colors: {
    enamel: ['#eaf1f8', '#d3e1ee', '#a6c2dd', '#6f9cc4', '#4f82b0', '#3b71a1', '#2c5f8e', '#234d74', '#1b3c5b', '#122a41'],
    label: ['#fffbeb', '#fff0bf', '#ffe48f', '#ffd75c', '#ffc933', '#f5b800', '#cc9a00', '#a37b00', '#7a5c00', '#523d00'],
  },
  defaultRadius: 'sm',
});

// Retry is off: a refusal is usually a decision the person should see at
// once, not a request worth repeating.
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <Notifications position="top-right" />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <SessionProvider>
            <App />
          </SessionProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
